import { constants } from './config';

export const postServiceCompanyOrder = (data) => ({
  type: constants.POST_SERVICE_COMPANY_ORDER,
  payload: data,
});

export const postServiceCompanyOrderSuccess = (data) => ({
  type: constants.POST_SERVICE_COMPANY_ORDER_SUCCESS,
  payload: data,
});

export const postServiceCompanyOrderFail = (error) => ({
  type: constants.POST_SERVICE_COMPANY_ORDER_FAIL,
  payload: error,
});

export const resetServiceCompanyOrder = () => ({
  type: constants.RESET_SERVICE_COMPANY_ORDER,
});
